// extracted by mini-css-extract-plugin
module.exports = {"year-wrapper":"_7a3fb80146--year-wrapper--VtKUC","content":"_7a3fb80146--content--ozKUI","button":"_7a3fb80146--button--hWSNG"};